import React from 'react';

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const Pagination = ({ total, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / itemsPerPage));
  const current = Math.min(Math.max(currentPage, 1), totalPages);

  const handleClick = (page) => {
    if (page < 1 || page > totalPages || page === current) return;
    scrollToTop();
    onPageChange(page);
  };

  const raw = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || Math.abs(i - current) <= 2) {
      raw.push(i);
    } else if (
      (i === 2 && current > 4) ||
      (i === totalPages - 1 && current < totalPages - 3)
    ) {
      raw.push('ELLIPSIS');
    }
  }
  const pages = raw.filter(
    (p, idx) => p !== 'ELLIPSIS' || raw[idx - 1] !== 'ELLIPSIS'
  );

  return (
    <nav>
      <ul className="pagination mb-0">
        <li className={`page-item${current === 1 ? ' disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => handleClick(current - 1)}
            aria-label="Previous"
            disabled={current === 1}
          >
            Prev
          </button>
        </li>

        {pages.map((p, idx) =>
          p === 'ELLIPSIS' ? (
            <li key={`e${idx}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li
              key={p}
              className={`page-item${p === current ? ' active' : ''}`}
            >
              <button className="page-link" onClick={() => handleClick(p)}>
                {p}
              </button>
            </li>
          )
        )}

        <li className={`page-item${current === totalPages ? ' disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => handleClick(current + 1)}
            aria-label="Next"
            disabled={current === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
